<!--
  ~ Copyright (C) 2019 - Potentially Ltd
  ~
  ~ Please see distribution for license.
  -->

<div class="achievements-section__badges-container" #content (scroll)="onBadgesContainerScroll($event)">
  <div class="achievements-section__badges" *ngIf="badgeCards?.length">
    <mat-card
      *ngFor="let badge of badgeCards"
      class="achievement-badge"
      [class.pointer]="canOpenPublicBadge"
      role="article"
      tabindex="0"
      (click)="canOpenPublicBadge ? onBadgeClicked(badge.userBadgeUid) : null"
      (keydown.enter)="canOpenPublicBadge ? onBadgeClicked(badge.userBadgeUid) : null"
      [attr.aria-label]="getTitle(badge.title)"
      [ngClass]="{ 'show-only-first-row': showOnlyFirstRow }"
    >
      <div class="achievement-badge__card-center">
        <div class="achievement-badge__card-center-bg" [style.background-color]="badge.color"></div>
        <ng-container *ngIf="!badge.isIndependent">
          <div
            class="achievement-badge__upload"
            [ngStyle]="{ 'background-image': badge.imageUrl ? 'url(&quot;' + badge.imageUrl + '&quot;)' : '' }"
          ></div>
          <span class="icon-container" [ngStyle]="{ 'background-image': badge.orgLogo ? 'url(&quot;' + badge.orgLogo + '&quot;)' : '' }">
          </span>
        </ng-container>
        <ng-container *ngIf="badge.isIndependent">
          <ptl-badge-image
            [imageUrl]="badge.imageUrl"
            [shape]="badge.shape"
            [colorScheme]="badge.colorScheme || { border: '#212529', background: '#ffffff' }"
          ></ptl-badge-image>
        </ng-container>
      </div>
      <div class="achievement-badge__card-footer">
        <div class="achievement-badge__card-text title">
          {{ getTitle(badge.title) }}
        </div>
        <br />
        <span
          class="achievement-badge__card-text description"
          role="note"
          [attr.aria-label]="'translations.global.ariaLabels.awardedBy' | transloco"
        >
          {{ 'translations.playlist.goals.label.awardedBy' | transloco }}</span
        >
        <div class="achievement-badge__card-text description bold" role="note" [attr.aria-label]="badge.issuedBy">
          {{ badge.issuedBy }}
        </div>
        <span
          class="achievement-badge__card-text description"
          role="note"
          [attr.aria-label]="badge.issuedOn | dateFormat: 'D MMMM y, HH:mm'"
        >
          {{ badge.issuedOn | dateFormat: 'D MMMM y, HH:mm' }}</span
        >
      </div>
    </mat-card>
  </div>
</div>

<div class="row-header__button" *ngIf="!editMode">
  <button mat-flat-button class="see-less-btn" *ngIf="loadedMore" (click)="onLoadLess()">
    {{ 'translations.global.button.seeLess' | transloco }}
  </button>
  <button
    mat-flat-button
    class="see-more-btn"
    *ngIf="(badges && badgeCards?.length < badges?.length) || canLoadMore"
    (click)="onShowMore()"
  >
    <mat-spinner *ngIf="loadingMore" [diameter]="20"></mat-spinner>
    <span class="see-more-btn-title">{{ 'translations.global.button.seeMore' | transloco }}</span>
  </button>
</div>
